import React from "react";
import Box from "@material-ui/core/Box";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Typography from "@material-ui/core/Typography";
import { useTheme } from "@material-ui/core/styles";
import useMediaQuery from "@material-ui/core/useMediaQuery";
const HotelCard = ({ item }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery("(max-width:750px)");

  return (
    <Card
      elevation={2}
      style={{
        display: "flex",
        flexDirection: isMobile ? "column" : "row",
        maxWidth: "670px",
        maxHeight: "400px",
        overflow: "hidden",
        minHeight: "190px",
        boxShadow: "0px 4px 12px rgba(0,0,0,0.1)",
        backgroundColor: theme?.agentTheme?.card?.main,
      }}
    >
      <Box
        sx={{
          width: isMobile ? "100%" : "50%",
          height: isMobile ? 200 : "100%",
          position: "relative",
          overflow: "hidden",
          flexShrink: 0,
          "& img": {
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "calc(100% + 10px)",
            objectFit: "cover",
            transform: "translateY(-10px)",
            transition: "transform 0.5s ease",
            cursor:"pointer"
          },
          "&:hover img": {
            transform: "scale(1.1) translateY(-10px)",
          },
        }}
      >
        <img src={item?.icon} alt="Family on the beach" />
      </Box>

      <CardContent
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          width: isMobile ? "100%" : "50%",
          p: "0.5rem",
        }}
      >
        <Typography
          variant="h6"
          style={{
            fontWeight: 600,
            color: theme.agentTheme.card.foreground,
          }}
        >
          {item?.name}
        </Typography>

        <Typography
          variant="body2"
          style={{
            marginTop: "0.5rem",
            marginBottom: "1rem",
            color: theme.agentTheme.card.secondary_foreground,
          }}
        >
          {item?.text}
        </Typography>
      </CardContent>
    </Card>
  );
};

export default HotelCard;
